// Types
import { Point } from '../../../common/maths/geometry/pointTypes';

// Utils
import { getScrollAsPoint } from '../../utils/dom/scrollableParentUtils';

export interface ZoomDomElementPropertyCache {
    clearCache: Function;
    getCachedValues: Function;
}

interface ZoomCachedValuesResponse {
    canvasViewportClientRect: DOMRect;
    canvasScroll: Point;
}

/**
 * To prevent layout thrashing (where every animation frame requires a layout/paint
 * due to accessing layout properties) we cache the layout properties after accessing them.
 */
export const createZoomDomElementPropertyCache = (): ZoomDomElementPropertyCache => {
    let canvasViewportClientRect: DOMRect | null;
    let canvasScroll: Point | null;

    /**
     * Clears the cached values, so they'll be re-fetched on the next invocation of getCachedValues.
     */
    const clearCache = () => {
        canvasViewportClientRect = null;
        canvasScroll = null;
    };

    /**
     * Gets the cached layout property values, or fetches fresh values if none are cached.
     */
    const getCachedValues = (canvasViewportElement: HTMLElement): ZoomCachedValuesResponse => {
        canvasViewportClientRect = canvasViewportClientRect || canvasViewportElement.getBoundingClientRect();
        canvasScroll = canvasScroll || getScrollAsPoint(canvasViewportElement);

        return {
            canvasViewportClientRect,
            canvasScroll,
        };
    };

    return {
        clearCache,
        getCachedValues,
    };
};
